import React from "react";
import { AnchorButton, Icon, Tag } from "@blueprintjs/core";
import { Tooltip2 } from "@blueprintjs/popover2";
import { Box, quarks, Text } from "ui-components";
// import { useSessionState } from '@maps-internal/neutron-react-client'
// import useSession from "ui-io/use-session";

import openInNewTab from "../../../utils/open-in-new-tab";
import { TaskCellProps } from "./task-cell";
import { styled } from "styled-components";


const TaskActionsUrlCell = ({ task }: TaskCellProps) => {
  const { companyID = "" } = task._raw;
  const configUrl = companyID ? `/configurations/create?companyID=${companyID}` : "";

  return (
    <Box mt="xsmall"  inline>
     
      <Box ml="small" inline>
        <Tooltip2
          content={
            <>
              Open Configuration for <u>{companyID}</u>
            </>
          }
        >
          <Tag
            interactive
            minimal
            intent="primary"
            onClick={() => openInNewTab(configUrl)}
          >
            Config
            <MenuIcon>
            <Icon icon="share" iconSize={13} />
            </MenuIcon>
          </Tag>
        </Tooltip2>
      </Box>
      {/* {brandBaseUrl ? (
        <Box ml="small" inline>
          <Tooltip2
            content={
              <>
                Open <u>{brandBaseUrl}</u>
              </>
            }
          >
            <Tag
              interactive
              minimal
              intent="primary"
              onClick={() => openInNewTab(brandBaseUrl)}
            >
              Base
              <MenuIcon icon="share" iconSize={13} />
            </Tag>
          </Tooltip2>
        </Box>
      ) : null} */}
    </Box>
  );
};

export default TaskActionsUrlCell;


export const MenuIcon = styled.span`
  margin-left: ${quarks.margins.small};
  cursor: pointer;
`